import { ICurrencyBudgetValueMapping } from '../types';

export const DEFAULT_BUDGET_VALUE_FOR_CURRENCY: ICurrencyBudgetValueMapping = {
  ARS: 3500,
  AUD: 35,
  BRL: 130,
  CAD: 30,
  CHF: 25,
  CLP: 22420,
  CNY: 175,
  COP: 100000,
  DKK: 175,
  DZD: 3500,
  EGP: 480,
  EUR: 25,
  GBP: 20,
  HKD: 200,
  IDR: 350000,
  INR: 2000,
  JPY: 3000,
  LBP: 37000,
  MAD: 250,
  MXN: 500,
  MYR: 100,
  NOK: 250,
  NZD: 40,
  PEN: 100,
  PHP: 1400,
  QAR: 100,
  SAR: 100,
  SEK: 250,
  SGD: 35,
  THB: 900,
  TWD: 750,
  USD: 20,
  VND: 500000,
};
